import React from 'react'
import FullView from '../../Components/Index/FullView/FullView';
import ReducedView from '../../Components/Index/ReducedView/ReducedView';
import { getApiUrl } from '../../env';
import { Alert, CircularProgress, Paper, Snackbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import axios from 'axios';
import process from "process";
import CategoryChooser from './CategoryChooser';
import LoadingSkeleton from './ReducedView/LoadingSkeleton';

const Index = () => {
  const [news, setNews] = useState({ hasMore: '', items: [] })
  const [loading, setLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState("Се вчитуваат содржини")
  const [activeTab, setActiveTab] = useState(0)
  const [errorBar, setErrorBar] = useState(false)

  useEffect(() => {
    updateNews()
  }, [])

  const changedTab = (ev, val) => {
    setActiveTab(val);
    if (val == 0) {
      updateNews()
    }
    if (val == 1) {
      updateNews("Local")
    }
    if (val == 2) {
      updateNews("Economy")
    }
    if (val == 3) {
      updateNews("World")
    }
    if (val == 4) {
      updateNews("ScienceTechnology")
    }
    if (val == 5) {
      updateNews("Sport")
    }
    if (val == 6) {
      updateNews("Culture")
    }
  }

  const updateNews = (category) => {
    setLoading(true)
    setLoadingMessage("Се вчитуваат содржини")
    const timeout = setTimeout(() => {
      setLoadingMessage("Пронајдени се нови содржини. Се сумаризираат и се одредува популарноста. Ве молиме почекајте!")
    }, 5000)
    const url = category ? getApiUrl() + "?category=" + category : getApiUrl();
    axios.get(url, {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    }).then(el => {
      setNews(el.data);
      setLoading(false)
      setLoadingMessage("");
      clearTimeout(timeout);
    }).catch(err => {
      setErrorBar(true)
      console.log(err);
    })
  }

  return (
    <div style={{ margin: '10px' }}>
      <Snackbar open={errorBar} autoHideDuration={6000} onClose={() => setErrorBar(false)}>
        <Alert onClose={() => setErrorBar(false)} severity="error" sx={{ width: '100%' }}>
          Се случи грешка при превземањето на вестите. Ве молиме пробајте повторно подоцна.
        </Alert>
      </Snackbar>
      <CategoryChooser changedTab={changedTab} value={activeTab} />
      {loading ?
        <div>
          {[...Array(15).keys()].map(el => (
            <LoadingSkeleton key={el} />
          ))}
        </div>
        :
        <div>
          <ReducedView news={news} doInject={activeTab == 0} />
          <footer id='footer'>
            <Paper style={{ width: '100%', padding: '3px 0', backgroundColor: '#1B2430', paddingTop: '20px', borderRadius: 0, height: '40px' }}>
              <a className='anchor' style={{ marginRight: '30px', color: 'white' }} href="/about">За Читај!</a>
              <a className='anchor' style={{ marginRight: '30px', color: 'white' }} href="/contribute">Придонеси</a>
            </Paper>
          </footer>
        </div>
      }
    </div>
  )
}

export default Index;